import { AutogenLayoutOfficeCheckRegisterReport } from "./autogen/AutogenLayoutOfficeCheckRegisterReport";

/**
 * Office Check Register Report - Extension class with custom business logic
 */
export class OfficeCheckRegisterReport extends AutogenLayoutOfficeCheckRegisterReport {

    override onLoad(): void {
        this.textboxVoidedStatus.selectedItem = this.textboxVoidedStatus.items[0];
        this.textboxClearedStatus.selectedItem = this.textboxClearedStatus.items[0];
    }
}
